"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorContext = void 0;
const react_1 = __importDefault(require("react"));
const processErrorDefault = function errorProcessor(error) {
    if (typeof error === 'string')
        return error;
    return (error === null || error === void 0 ? void 0 : error.message) || '';
};
exports.ErrorContext = react_1.default.createContext({
    getErrorMessage: processErrorDefault,
});
exports.default = { ErrorContext: exports.ErrorContext };
